module.exports = __webpack_public_path__ + "Flag-178.199f7ca3b1d54ca5ba969448754bc7c0.svg";